import { css } from '@lastbrand/web-ui-styled-system/css'

// Figma: Quince Design System 2.0 → Widgets → ProductProperty (node 8220:16881).
// The Figma `breakpoint` prop maps to CSS-responsive tokens: `base` = mobile, `lg` = desktop.

export const containerCss = css({
  display: 'flex',
  flexDirection: 'column',
  width: 'full',
  // No `gap` here — a fieldset's <legend> is not a normal flex child, so the
  // header→content offset lives on contentCss (marginTop) instead.
})

export const headerCss = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'space-8',
  width: 'full',
  textStyle: { base: 'body-12', lg: 'body-14' },
  fontWeight: 500,
  color: 'black',
})

export const labelCss = css({
  minWidth: 0,
  // Figma: the action button sits at the right edge on mobile (text takes the
  // free space) but directly after the text on desktop (text hugs its content).
  flex: { base: '1 0 0%', lg: '0 0 auto' },
  // Inline text flow (no inner flex) so long values wrap naturally. The property
  // and value are separated by a plain space rather than Figma's 4px gap — a
  // deviation, but visually equivalent for inline text.
})

export const selectedValueCss = css({
  fontWeight: 400,
})

export const contentCss = css({
  marginTop: 'space-12',
  width: 'full',
})
